import { Button, Modal } from '@dev-spendesk/grapes';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

type WireTransfersApprovedModalProps = {
  count: number;
  isOpen: boolean;
  onComplete: () => void;
};

export const WireTransfersApprovedModal = ({
  count,
  isOpen,
  onComplete,
}: WireTransfersApprovedModalProps) => {
  const { t } = useTranslation('global');

  const title = t(
    'submitMyInvoice.scheduled.wireTransfer.transfersConfirmedTitle',
    {
      count,
    },
  );

  return (
    <Modal
      actions={[
        <Button
          key="continue"
          text={t('submitMyInvoice.scheduled.wireTransfer.continue')}
          variant="primaryBrand"
          onClick={onComplete}
        />,
      ]}
      iconName="arrow-left-right"
      iconVariant="info"
      title={title}
      isOpen={isOpen}
    />
  );
};
